import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl } from '@material-ui/core';
import Select from 'react-select';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import './reports.scss';

function SectionCard(props) {
    const {courseResultData, setActiveAttempts, setActiveKey} = props
    const t = useTranslations();
    const hasSectionPassingPercent = courseResultData?.some(attempt => 
        attempt?.some(section => section?.sectionPassingPercent != null && section?.sectionPassingPercent > 0)
    );
    
    // Prepare options for the Select component
    const options = (courseResultData || []).map((item, index) => ({
        value: item,
        label: `Attempt ${index+1}`
    }));

    const [selectedAttempt, setSelectedAttempt] = useState(options[0]);

    useEffect(() => {
        handleAttemptChange(selectedAttempt);
    },[])

    const handleAttemptChange = (selectedOption) => {
        const index = options?.indexOf(selectedOption);
        setActiveKey(index)
        setActiveAttempts(selectedOption?.value)
        setSelectedAttempt(selectedOption);
    };

    const renderSectionResult = (item) => {
        if (!(item?.sectionPassingPercent != null && item?.sectionPassingPercent > 0)) {
            return <span>-</span>;
        }

        const percentage = (item?.score / item?.total) * 100;
        const isPassed = percentage >= item?.sectionPassingPercent;
        return (
            <span className={`result-tag ${isPassed ? "passed" : "failed"}`}>
                {isPassed ? "PASSED" : "FAILED"}
            </span>
        );
    };

    return (
        <Box className="attempt-card-box graph-box-container">
            <TableContainer component={Paper} className='table-container'>
                <div className="dropdown-container">
                    <h2>{t('Section_wise_score')}</h2>
                    <FormControl className='dropdown-data'>
                    <Select 
                        id="department"
                        value={selectedAttempt}
                        onChange={handleAttemptChange}
                        options={options}
                        styles={{
                            option: (provided) => ({
                            ...provided,
                            fontWeight: '400'
                            }),
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            dropdownIndicator: (provided) => ({
                                ...provided,
                                color: '#202020'
                            }),
                            indicatorSeparator: (provided) => ({
                                ...provided,
                                backgroundColor: '#202020'
                            }),
                            placeholder: (provided) => ({
                                ...provided,
                                color: '#202020',
                                opacity: 1
                            })
                        }}
                        menuPortalTarget={document.body}
                    />
                    </FormControl>
                </div>
                <Table className='table-data'>
                    <TableHead>
                        <TableRow>
                            <TableCell className="column-header">{t('Section')}</TableCell>
                            <TableCell className="column-header">{t('score')}</TableCell>
                            {hasSectionPassingPercent && <TableCell className="column-header" style={{width: '25%'}}>{t('Min. %')}</TableCell>}
                            {hasSectionPassingPercent && <TableCell className="column-header">{t('Result')}</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedAttempt?.value?.length> 0 &&  selectedAttempt?.value?.map((item, index) => (
                            <TableRow key={item?.section?._id || item?.section?.en || `${item?.score}-${item?.total}-${item?.sectionPassingPercent}`} className="body-row">
                                <TableCell>{item?.section?.en }</TableCell>
                                <TableCell>{item?.score}/{item?.total}</TableCell>
                                {hasSectionPassingPercent && (
                                    <TableCell>
                                        {(item?.sectionPassingPercent != null && item?.sectionPassingPercent > 0) ? `${item?.sectionPassingPercent}%` : '-'}
                                    </TableCell>
                                )}
                                {hasSectionPassingPercent && (
                                    <TableCell>
                                        {renderSectionResult(item)}
                                    </TableCell>
                                )}

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

SectionCard.propTypes = {
    courseResultData: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                score: PropTypes.number,
                total: PropTypes.number,
                sectionPassingPercent: PropTypes.number,
                section: PropTypes.shape({
                    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    en: PropTypes.string,
                }),
            })
        )
    ),
    setActiveAttempts: PropTypes.func,
    setActiveKey: PropTypes.func,
};

export default SectionCard;
